import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  img {
    width: 500px;
  }
`

export const Center = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
